
export const makeGuestApps = (apps: { [key: string]: any }[], arr: string[]) => {
   for ( let i = 0; i < apps.length; i++ ) {
      apps[i].totalLikes = 0;
      for ( let j = 0; j < arr.length; j++ ) {
          if ( apps[i].lesson_id === arr[j] ) {
                apps[i].totalLikes = 99;
          }
      }
   }

   return apps;
}
